export class Member {
  constructor(
    public name: string = '',
    public gender: string = '',
    public level: number = 5,
    public unit:string = '',
    public tutor:string = '',
    public group:string = '',
    public dateOfBirth:string = '',
    public avatar = [0,0,0,0],
    public created = '',
    public createdBy = '',
    public modified = '',
    public modifiedBy = ''
  ) {  }
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/member.ts